"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkForThemeProps = void 0;
const checkForThemeProps = theme => {
  let themeColors = {};
  if (!theme?.theme) {
    themeColors["theme"] = "white";
  } else if (theme?.theme) {
    themeColors["theme"] = theme.theme;
  }
  if (!theme?.color) {
    themeColors["color"] = "#252A2E";
  } else if (theme?.color) {
    themeColors["color"] = theme.color;
  }
  if (!theme?.backgroundColor) {
    themeColors["backgroundColor"] = "#fff";
  } else if (theme?.backgroundColor) {
    themeColors["backgroundColor"] = theme.backgroundColor;
  }
  if (!theme?.ctaOne) {
    themeColors["ctaOne"] = "primary--1";
  } else if (theme?.ctaOne) {
    themeColors["ctaOne"] = theme.ctaOne;
  }
  if (!theme?.ctaTwo) {
    themeColors["ctaTwo"] = "primary--2";
  } else if (theme?.ctaTwo) {
    themeColors["ctaTwo"] = theme.ctaTwo;
  }
  if (!theme?.iconColor) {
    themeColors["iconColor"] = "#252A2E";
  } else if (theme?.iconColor) {
    themeColors["iconColor"] = theme.iconColor;
  }
  if (!theme?.accordionIconColor) {
    themeColors["accordionIconColor"] = "#0063A3";
  } else if (theme?.accordionIconColor) {
    themeColors["accordionIconColor"] = theme.accordionIconColor;
  }
  return themeColors;
};
exports.checkForThemeProps = checkForThemeProps;